import type { Legal } from "@brookbush/types";

import type { GetStaticProps } from "next";
import useSWR, { type SWRResponse } from "swr";

import Container from "~/components/Container";
import DottedBackground from "~/components/DottedBackground";
import TextBlock from "~/components/TextBlock";
import type { NextPageWithProps } from "~/types";
import fetcher from "~/utils/fetcher.client";

const PrivacyPolicyPage: NextPageWithProps = () => {
	const { data: legal } = useSWR<Legal>(
		`/company-info/legal`,
	) as SWRResponse<Legal> & {
		data: Legal;
	};

	return (
		<DottedBackground>
			<Container>
				<div className="mx-auto flex max-w-screen-lg flex-col gap-6 py-2 sm:gap-16 sm:py-10">
					<div className="flex flex-col justify-center gap-4 text-center">
						<h1 className="font-semibold text-3xl md:text-5xl">
							Privacy Policy
						</h1>
						<p className="text-lg">
							Learn more about the privacy policy for operating Brookbush
							Institute and how it affects you.
						</p>
					</div>

					<TextBlock className="max-w-5xl" value={legal.privacyPolicy} />
				</div>
			</Container>
		</DottedBackground>
	);
};

export const getStaticProps: GetStaticProps = async () => {
	const legal = await fetcher("/company-info/legal");

	return {
		props: {
			fallback: {
				"/company-info/legal": legal,
			},
		},
	};
};

export default PrivacyPolicyPage;
